import React, { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import Spinner from "../common/spinner";
import { ToastContainer, toast } from "react-toastify";
import "./shopifyMerchants.scss";
import * as service from "./shopifyMerchantsServices";
import { log, getMapIdBasedonEnvironment } from "../../helper/helper";
import destination from "../../assets/destination.png";
import { GoogleMap, Marker } from "@react-google-maps/api";
import { Col, Row, Table, Button } from "antd";

function ShopifyMerchants(props) {
  const [customers, setCustomers] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [positions, setPositions] = useState([]);

  const [map, setMap] = React.useState(null);
  const onLoadBounds = (map) => {
    if (!map) {
      return;
    }
    const bounds = new window.google.maps.LatLngBounds();
    positions.forEach((child) => {
      bounds.extend(new window.google.maps.LatLng(child.lat, child.lng));
    });
    map.fitBounds(bounds);
    setMap(map);
  };

  const defaultMapOptions = {
    fullscreenControl: true,
  };

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  const containerStyle = {
    width: "100%",
    height: "50vh",
  };

  const loadGoogleMap = () => {
    return (
      <GoogleMap
        mapContainerStyle={containerStyle}
        zoom={13}
        onLoad={onLoadBounds}
        onUnmount={onUnmount}
        defaultOptions={defaultMapOptions}
        options={{
          mapId: getMapIdBasedonEnvironment(),
        }}
      >
        {positions.map((marker) => (
          <Marker
            position={marker}
            key={marker.lat + marker.lng + Math.random()}
            icon={{
              url: marker.icon,
            }}
          />
        ))}

        <></>
      </GoogleMap>
    );
  };

  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (!user) {
        return props.history.replace("/login");
      }
      adminGetAllActiveShopForShopify();
    });
  }, []);

  const renderSpinner = () => {
    if (isLoading) {
      return <Spinner />;
    }
  };

  const adminGetAllActiveShopForShopify = async () => {
    setLoading(true);
    try {
      const result = await service.adminGetAllActiveShopForShopify();
      setLoading(false);
      log(result);
      if (result) {
        setLoading(false);
        switch (result.data.code) {
          case 200:
            // setTransports(result.data.customer);
            const formattedData = result.data.customer.map((item, index) => ({
              key: index.toString(),
              businessName: item.business_name,
              customerName: item.given_name + " " + item.last_name,
              phoneNumber: item.mobile_number,
              email: item.email_address,
              address: item.address,
              shopifyPlan: item.shop_shopify_plan_type,
              websiteURL: (
                <a
                  href={
                    item.shop.startsWith("http")
                      ? item.shop
                      : `https://${item.shop}`
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {item.shop}
                </a>
              ),
              firstActivation: item.shopify_app_first_activation_date,
              latestUpdate: item.shopify_app_latest_update_date,
              rawData: item,
            }));
            setCustomers(formattedData);

            let positionsData = [];
            for (const trip of result.data.customer) {
              positionsData.push({
                lat: trip.location_lat,
                lng: trip.location_lng,
                icon: destination,
                zIndex: 9,
              });
            }
            setPositions(positionsData);
            return;
          case 401:
            toast.error(result.data.message);
            return props.history.replace("/login");
          case 500:
            return toast.error(result.data.message);
          default:
            return toast.error(result.data.message);
        }
      }
    } catch (error) {
      log(error);
      toast.error(error.message);
    }
    setLoading(false);
  };

  const columns = [
    {
      title: "Business Name",
      dataIndex: "businessName",
      key: "businessName",
    },
    {
      title: "Customer Name",
      dataIndex: "customerName",
      key: "customerName",
    },
    {
      title: "Phone Number",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
    },
    {
      title: "Shopify Plan",
      dataIndex: "shopifyPlan",
      key: "shopifyPlan",
    },
    {
      title: "Website URL",
      dataIndex: "websiteURL",
      key: "websiteURL",
    },
    {
      title: "First Activation",
      dataIndex: "firstActivation",
      key: "firstActivation",
    },
    {
      title: "Latest Update",
      dataIndex: "latestUpdate",
      key: "latestUpdate",
    },
    {
      title: "More Details",
      dataIndex: "moreDetails",
      key: "moreDetails",
      render: (_, record) => (
        <Button
          type="link"
          className="single-view"
          onClick={() => {
            props.history.push(
              "/home/findCustomer/customerList/customerSingle",
              {
                customerId: record.rawData.customer_uid,
                customerType: "shopify",
              }
            );
          }}
        >
          View
        </Button>
      ),
    },
  ];

  return (
    <div className="show-all-list data-server-list">
      <ToastContainer />
      {renderSpinner()}
      {positions.length > 0 && <div className="map"> {loadGoogleMap()}</div>}
      <h6 style={{ margin: "20 0" }}>
        Found {customers.length} {customers.length > 1 ? "results" : "result"}
      </h6>
      <Row>
        <Col span={24}>
          <Table
            dataSource={customers}
            columns={columns}
            pagination={false}
            scroll={{ x: 400, y: "auto" }}
          />
        </Col>
      </Row>
    </div>
  );
}
export default ShopifyMerchants;
